import React, { useEffect, useMemo, useRef, useState } from "react";
import styled, { css, createGlobalStyle } from "styled-components";
import { Button, Form } from "react-bootstrap";
// import Router
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";

import "react-datepicker/dist/react-datepicker.css";
import { readDreamDraft } from "../../utils/dreamDraft";

const StyledButton = styled.button`
  padding: 10px 20px; /* 荳贋ｸ・0px縲∝ｷｦ蜿ｳ15px縺ｮ蜀・Κ繝代ョ繧｣繝ｳ繧ｰ繧定ｨｭ螳・*/
  border: none; /* 繝懊・繝繝ｼ繧呈ｶ医☆ */
  color: #0072bc; /* 譁・ｭ苓牡繧定ｨｭ螳・*/
  background-color: #d5e5f2;
  cursor: pointer; /* 繧ｫ繝ｼ繧ｽ繝ｫ繧偵・繧､繝ｳ繧ｿ縺ｫ螟画峩 */
  font-size: 12px; /* 繝輔か繝ｳ繝医し繧､繧ｺ繧定ｨｭ螳・*/
  border-radius: 5px; /* 隗偵ｒ荳ｸ縺上☆繧・*/
  // margin-left: 3px;
  // margin-bottom: 5px;
  text-align: center; /* 繝・く繧ｹ繝医ｒ荳ｭ螟ｮ謠・∴縺ｫ縺吶ｋ */
  align-items: center; /* 蝙ら峩譁ｹ蜷代・荳ｭ螟ｮ謠・∴ */
  justify-content: center; /* 豌ｴ蟷ｳ譁ｹ蜷代・荳ｭ螟ｮ謠・∴ */
  display: flex;

  ${(props) =>
    props.selected &&
    `
    color: white;
    background-color: #267ca7;
  `}

  @media (max-width: 768px) {
    font-size: 10px; // 繝輔か繝ｳ繝医ｒ蟆上＆縺・
    padding: 8px 12px; // 繝代ョ繧｣繝ｳ繧ｰ繧りｪｿ謨ｴ
  }
`;

const ThumbGrid = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  align-content: start;
`;

const ThumbItem = styled.div`
  width: 100%;
  min-height: 0;
`;

const ThumbButton = styled.button`
  all: unset; /* 竊・雜・㍾隕√Ｃutton縺ｮ菴呵ｨ医↑CSS繧貞・驛ｨ豸医☆ */
  display: block;
  width: 100%;
  cursor: pointer;
`;

const ThumbSquare = styled.span`
  position: relative;
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;

  /* 笘・％繧後′譛ｬ蜻ｽ・夂｢ｺ螳溘↓鬮倥＆繧剃ｽ懊ｋ */
  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }
`;

const ThumbImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain; /* cover縺ｧ繧０K */
  display: block;
`;

const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownButton = styled.button`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ced4da;
  background-color: white;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  text-align: left;
  color: black; /* 譁・ｭ苓牡繧帝ｻ偵↓險ｭ螳・*/
`;

const DropdownMenu = styled.ul`
  position: absolute;
  width: 100%;
  background-color: white;
  border: 1px solid #ced4da;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  padding: 0;
  margin: 0;
  list-style: none;
  z-index: 1000;
  ${({ $isOpen }) => (!$isOpen ? "display: none;" : "display: block;")}/* 菫ｮ豁｣ */
`;

const DropdownMenuItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: #f5f5f5;
`;

const RegisterForm = styled(Form)`
  width: 500px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: white;

  @media (max-width: 768px) {
    width: 90%; // 繧ｹ繝槭・縺ｧ縺ｯ逕ｻ髱｢縺ｫ蜿弱∪繧九し繧､繧ｺ
    padding: 20px;
  }
`;

const RegisterButton = styled(Button)`
  width: 100%;
`;

const ChapterSelectButton = styled(Button)`
  background-color: gray;
  border: none;
  width: 35%;
`;

const CancelButton = styled(Button).attrs({ variant: "secondary" })`
  && {
    background-color: gray;
    border: none;
    width: 10%;
    color: #000;
  }
  &&:hover,
  &&:focus,
  &&:active {
    background-color: gray;
    border-color: gray;
    color: #000;
    box-shadow: none;
  }
`;

const SpacedFormGroup = styled(Form.Group)`
  margin-bottom: 15px;
`;

const SpacedTagsFormGroup = styled(Form.Group)`
  display: flex; /* Flexbox 繧呈怏蜉ｹ縺ｫ縺吶ｋ */
  flex-wrap: wrap; /* 繧ｳ繝ｳ繝・Φ繝・′繧ｳ繝ｳ繝・リ縺ｮ蟷・ｒ雜・∴縺溷ｴ蜷医↓謚倥ｊ霑斐☆ */
  align-items: center; /* 繧｢繧､繝・Β繧貞桙逶ｴ譁ｹ蜷代・荳ｭ螟ｮ縺ｫ驟咲ｽｮ */
  justify-content: flex-start; /* 繧｢繧､繝・Β繧呈ｰｴ蟷ｳ譁ｹ蜷代・髢句ｧ狗ｫｯ縺ｫ驟咲ｽｮ */
  gap: 4px; /* 繝懊ち繝ｳ髢薙・髫咎俣繧定ｨｭ螳・*/
  margin-bottom: 5px;
`;

const SpacedForm = css`
  width: 440px; // 莉ｻ諢上・讓ｪ蟷・ｒ謖・ｮ・
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  height: 500px; // 莉ｻ諢上・鬮倥＆繧呈欠螳・
  resize: none; // 繝ｦ繝ｼ繧ｶ繝ｼ縺後し繧､繧ｺ繧貞､画峩縺吶ｋ縺ｮ繧帝亟縺・
  background-color: white;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const GlobalStyle = createGlobalStyle`
  .custom-form-control {
    ${SpacedForm}
  }
  .form-control {
    color: black;
  }
`;

const styles = {
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
    padding: "16px", // 遶ｯ繧ｮ繝ｪ繧ｮ繝ｪ蝗樣∩・医せ繝槭・縺ｧ縺ｮ螳牙・繝槭・繧ｸ繝ｳ・・
  },
  modalContent: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    width: "min(640px, 92vw)", // 逕ｻ髱｢蟷・↓蜿弱ａ繧・
    maxHeight: "min(85vh, calc(100dvh - 32px))",
    boxSizing: "border-box",
    overflow: "hidden",
    minHeight: 0,
  },
  // 繧ｹ繧ｯ繝ｭ繝ｼ繝ｫ蟆ゆｻｻ繝ｬ繧､繝､繝ｼ・医・繝・ム縺ｨ繝輔ャ繧ｿ縺ｫ謖溘・・・
  scrollArea: {
    flex: "1 1 auto",
    minHeight: 0, // 笘・縺薙％繧る㍾隕・
    overflowX: "hidden",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    overscrollBehavior: "contain",
    padding: "4px 2px 0",
  },
  // 笆ｼ 霑ｽ蜉・壹し繝繝阪う繝ｫ繧ｰ繝ｪ繝・ラ逕ｨ・育｢ｺ螳溘↓荳ｭ縺ｧ繧ｹ繧ｯ繝ｭ繝ｼ繝ｫ・・
  thumbGrid: {
    display: "grid",
    gap: "10px",
    gridTemplateColumns: "repeat(auto-fill, minmax(90px, 1fr))",
    alignContent: "start",
  },
  // 笆ｼ 霑ｽ蜉・壹し繝繝阪う繝ｫ1譫壼・・域ｭ｣譁ｹ蠖｢繝ｩ繝・ヱ・・
  square: {
    position: "relative",
    display: "block",
    width: "100%",
    aspectRatio: "1 / 1", // 豁｣譁ｹ蠖｢繧堤｢ｺ菫晢ｼ・
    border: "1px solid #ccc",
    borderRadius: "8px",
    overflow: "hidden",
  },
  // 笆ｼ 霑ｽ蜉・夂判蜒上ｒ繝ｩ繝・ヱ縺ｫ繝輔ぅ繝・ヨ
  squareImg: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
  },
};

const RequiredBadge = styled.span`
  background-color: #dc3545;
`;

const ZoomWrapper = styled.div`
  transform: scale(1);
  transform-origin: top left;
  /* scale 縺吶ｋ縺ｨ隕∫ｴ螳溘し繧､繧ｺ縺檎ｸｮ繧縺ｮ縺ｧ陬懈ｭ｣ */
  width: 100%;
`;

const TagBox = styled.div` ... width: 100%; `;
const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: #fff;
  &:focus-within {
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);
  }
`;
const Chip = styled(StyledButton).attrs({ as: "span" })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  /* Chip 縺ｯ繧ｯ繝ｪ繝・け縺ｧ菴輔ｂ縺励↑縺・ｼ暗・縺縺大渚蠢懶ｼ・*/
  cursor: default;
  user-select: none;

  /* 繝懊ち繝ｳ繝帙ヰ繝ｼ濶ｲ縺ｪ縺ｩ縺ｯ縺昴・縺ｾ縺ｾ縺ｧ繧０K縺縺後，hip縺ｯ螟牙喧縺輔○縺溘￥縺ｪ縺・ｴ蜷医・蝗ｺ螳・*/
  &:hover {
    background-color: #d5e5f2;
    color: #0072bc;
  }
`;

// ﾃ・繝懊ち繝ｳ縺ｯChip縺ｮ荳ｭ縺ｫ蜿弱∪繧九ｈ縺・↓繝溘ル繝槭Β縺ｫ
// const RemoveChipBtn = styled.button`
//   border: none;
//   background: transparent;
//   cursor: pointer;
//   padding: 0 4px;
//   line-height: 1;
//   font-size: 14px; /* ﾃ・縺ｮ隕冶ｪ肴ｧ繧貞ｰ代＠縺縺台ｸ翫￡繧・*/
//   color: inherit; /* Chip 縺ｮ譁・ｭ苓牡縺ｫ蜷医ｏ縺帙ｋ */

//   /* 繝帙ヰ繝ｼ縺ｧ蟆代＠縺縺大ｼｷ隱ｿ */
//   &:hover {
//     opacity: 0.7;
//   }
// `;

const Input = styled.input`
  flex: 1; /* 谿九ｊ繧ｹ繝壹・繧ｹ繧貞・驛ｨ菴ｿ縺・*/
  width: 100%; /* 讓ｪ蟷・＞縺｣縺ｱ縺・↓ */
  min-width: 0; /* flexbox縺ｧ邵ｮ繧譎ゅ↓蛻ｶ髯舌ｒ螟悶☆ */
  border: none;
  outline: none;
  font-size: 14px;
`;

export function TagFreeInput({ value, onChange, maxTags = 10, placeholder = "タグを入力（カンマ・スペース・Enter・Tabで追加）" }) {
  const [q, setQ] = useState("");
  const [isComposing, setIsComposing] = useState(false);

  const names = useMemo(() => new Set((value || []).map((v) => v.trim().toLowerCase())), [value]);

  const canAddMore = (value || []).length < maxTags;

  const pushTag = (name) => {
    if (!canAddMore) return;
    const n = (name || "").trim();
    if (!n) return;
    const norm = n.toLowerCase();
    if (names.has(norm)) return;
    onChange([...(value || []), n]);
  };

  const commitFromBuffer = (buffer) => {
    const parts = (buffer || "")
      .split(/[,\s]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    let current = [...(value || [])];
    for (const p of parts) {
      if (current.length >= maxTags) break;
      const norm = p.toLowerCase();
      if (!current.map((x) => x.toLowerCase().trim()).includes(norm)) {
        current.push(p);
      }
    }
    onChange(current);
  };

  const handleKeyDown = (e) => {
    if (isComposing) return;

    if (e.key === "," || e.key === " " || e.key === "Enter" || e.key === "Tab") {
      if (q.trim()) {
        e.preventDefault();
        commitFromBuffer(q);
        setQ("");
      } else if (e.key === "Backspace" && (value || []).length > 0) {
        e.preventDefault();
        const next = [...value];
        next.pop();
        onChange(next);
      }
    } else if (e.key === "Backspace" && !q && (value || []).length > 0) {
      const next = [...value];
      next.pop();
      onChange(next);
    }
  };

  const handlePaste = (e) => {
    const text = e.clipboardData.getData("text");
    if (!text) return;
    if (/[,\s]/.test(text)) {
      e.preventDefault();
      commitFromBuffer((q + " " + text).trim());
      setQ("");
    }
  };

  return (
    <TagBox>
      <ChipRow>
        {(value || []).map((t, i) => (
          <Chip key={`${t}-${i}`}>
            #{t}
            {/* <RemoveChipBtn type="button" aria-label={`${t} 繧貞炎髯､`} onClick={() => onChange(value.filter((_, idx) => idx !== i))}>
              ﾃ・
            </RemoveChipBtn> */}
          </Chip>
        ))}
        <Input value={q} placeholder={canAddMore ? placeholder : `譛螟ｧ ${maxTags} 蛟九∪縺ｧ`} onChange={(e) => setQ(e.target.value)} onKeyDown={handleKeyDown} onPaste={handlePaste} onCompositionStart={() => setIsComposing(true)} onCompositionEnd={() => setIsComposing(false)} />
      </ChipRow>
    </TagBox>
  );
}

const RegisterPage = () => {
  const [selectedTags, setSelectedTags] = useState([]);
  const maxTags = 10; // 繧ｿ繧ｰ縺ｮ譛螟ｧ驕ｸ謚樊焚
  const [isOpen, setIsOpen] = useState(false); // 繝｡繝九Η繝ｼ縺碁幕縺・※縺・ｋ縺九・迥ｶ諷九ｒ邂｡逅・
  const [selectedOption, setSelectedOption] = useState("選択してください"); // 驕ｸ謚槭＆繧後◆繧ｪ繝励す繝ｧ繝ｳ縺ｮ迥ｶ諷九ｒ邂｡逅・
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false); // 繝｢繝ｼ繝繝ｫ縺ｮ髢矩哩迥ｶ諷狗ｮ｡逅・
  const [errMessage, setErrMessage] = useState(null); // 繧ｨ繝ｩ繝ｼ繝｡繝・そ繝ｼ繧ｸ
  const [showErrorModal, setShowErrorModal] = useState(false); // 迥ｶ諷狗ｮ｡逅・
  const [eventDate, setEventDate] = useState(null); // 繧ｫ繝ｬ繝ｳ繝繝ｼ譌･莉・

  const MANIFEST_URL = "/img/manifest.json";
  const categoryImageMap = {
    sports: ["sports"],
    company: ["company", "entrepreneurship"],
    entrepreneurship: ["entrepreneurship", "company"],
    career: ["company", "entrepreneurship", "sports"],
    romance: ["romance"],
    study: ["literature", "self_satisfaction", "company"],
    self_satisfaction: ["self_satisfaction", "literature"],
    literature: ["literature", "self_satisfaction"],
  };

  async function loadCategoryImages(mappedCategory) {
    console.log("[loadCategoryImages] mappedCategory:", mappedCategory);
    console.log("[loadCategoryImages] MANIFEST_URL:", MANIFEST_URL);

    const url = `${MANIFEST_URL}?v=${Date.now()}`; // 繧ｭ繝｣繝・す繝･蝗樣∩繧りｿｽ蜉
    const res = await fetch(url, { cache: "no-store" });

    console.log("[loadCategoryImages] res.ok:", res.ok, "status:", res.status);
    console.log("[loadCategoryImages] res.url:", res.url);
    console.log("[loadCategoryImages] content-type:", res.headers.get("content-type"));

    if (!res.ok) throw new Error(`manifest.json fetch failed: ${res.status}`);

    const manifest = await res.json();
    console.log("[loadCategoryImages] manifest keys:", Object.keys(manifest));

    // 譛溷ｾ・く繝ｼ縺檎┌縺代ｌ縺ｰ蛻･迚ｩ・・WA manifest遲会ｼ・
    const expectedKeys = ["sports", "company", "entrepreneurship", "romance", "self_satisfaction", "literature"];
    if (!expectedKeys.some((k) => k in manifest)) {
      console.error("[loadCategoryImages] Unexpected manifest (maybe PWA manifest):", manifest);
      throw new Error("Unexpected manifest.json (not image manifest)");
    }

    const folderKeys = categoryImageMap[mappedCategory];
    console.log("[loadCategoryImages] folderKeys:", folderKeys);

    if (!folderKeys || folderKeys.length === 0) {
      console.error("[loadCategoryImages] folderKey undefined. mappedCategory:", mappedCategory);
      return [];
    }

    const images = [...new Set(folderKeys.flatMap((key) => manifest[key] || []))];
    console.log("[loadCategoryImages] images length:", images.length, "sample:", images.slice(0, 5));
    return images;
  }

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleImageClick = (imagePath) => {
    setSelectedImage(imagePath);
    closeModal();
  };

  const handleTagButtonClick = (event, tag) => {
    event.preventDefault();

    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      // 繧ｿ繧ｰ縺梧怙螟ｧ謨ｰ縺ｫ驕斐＠縺ｦ縺・↑縺・ｴ蜷医∬ｿｽ蜉縺吶ｋ
      if (selectedTags.length < maxTags) {
        setSelectedTags([...selectedTags, tag]);
      }
    }
  };

  const location = useLocation();

  const BlockLabel = styled(Form.Label)`
    display: block;
    margin-bottom: 5px;
    flex-basis: 100%;
  `;

  useEffect(() => {
    if (location.state?.eventDetails) {
      const rawDate = location.state.eventDetails["目標実現日"];
      const formattedDate = rawDate instanceof Date ? rawDate : new Date(rawDate);
      setEventDate(formattedDate);

      setSelectedOption(location.state.eventDetails["カテゴリ"] || "選択してください");

      setSelectedImage(location.state.eventDetails["目標イメージ画像"] || null);

      const mappedCategory = categoryMap[location.state.eventDetails["カテゴリ"]];
      loadCategoryImages(mappedCategory)
        .then((imgs) => setImageList(imgs))
        .catch((e) => {
          console.error(e);
          setImageList([]);
          toast.error("画像一覧の取得に失敗しました");
        });

      const rawTags = location.state.eventDetails["タグ"];
      const restoredTags = rawTags ? rawTags.split(",").map((tag) => tag.trim()) : [];
      setSelectedTags(restoredTags);

      setEventDetails((prev) => ({
        ...location.state.eventDetails,
        "目標実現日": formattedDate || "",
      }));
    }
  }, [location.state]);

  useEffect(() => {
    setEventDetails((prevDetails) => ({
      ...prevDetails,
      "タグ": selectedTags.join(", "),
      "目標イメージ画像": selectedImage,
    }));
  }, [selectedTags, selectedImage]);

  useEffect(() => {
    setEventDetails((prevDetails) => ({
      ...prevDetails,
      "目標実現日": eventDate ? eventDate.toISOString().split("T")[0] : "",
    }));
  }, [eventDate]);

  const targetRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleDropdown = () => {
    // setIsOpen(!isOpen);
    setIsOpen((prev) => !prev); // 繝｡繝九Η繝ｼ縺ｮ陦ｨ遉ｺ・城撼陦ｨ遉ｺ繧貞・繧頑崛縺・
    console.log("Dropdown state:", !isOpen);
  };

  const categoryMap = {
    "スポーツ": "sports",
    "会社": "company",
    "起業": "entrepreneurship",
    "職業・キャリア": "career",
    "恋愛": "romance",
    "資格・勉強": "study",
    "自己満足": "self_satisfaction",
    "漫画、文学": "literature",
  };

  const handleOptionClick = (name, category) => {
    console.log(category);
    setSelectedOption(category);

    console.log("selected category:", JSON.stringify(category));
    const mappedCategory = categoryMap[category];
    console.log("mappedCategory:", mappedCategory);

    setEventDetails((prevDetails) => ({
      ...prevDetails,
      "カテゴリ": category,
    }));
    setIsOpen(false);

    loadCategoryImages(mappedCategory)
      .then((imgs) => setImageList(imgs))
      .catch((e) => {
        console.error(e);
        setImageList([]);
        toast.error("画像一覧の取得に失敗しました");
      });

    setSelectedImage(null);
  };

  const [categories, setCategories] = useState([
    "スポーツ",
    "会社",
    "起業",
    "職業・キャリア",
    "恋愛",
    "資格・勉強",
    "自己満足",
    "漫画、文学",
  ]);

  useEffect(() => {
    setCategories([
      "スポーツ",
      "会社",
      "起業",
      "職業・キャリア",
      "恋愛",
      "資格・勉強",
      "自己満足",
      "漫画、文学",
    ]);
  }, []);

  const [eventDetails, setEventDetails] = useState({
    "無謀な夢": readDreamDraft(),
    "目標実現日": "",
    "目標イメージ画像": "",
    "カテゴリ": "",
    "タグ": "",
    "無謀な夢の詳細": "",
  });

  const handleInputChange = (e) => {
    setEventDetails({
      ...eventDetails,
      [e.target.name]: e.target.value,
    });
  };

  const navigate = useNavigate();

  const handleClick = () => {
    const missingFields = [];
    if (!eventDetails["無謀な夢"]) missingFields.push("タイトル");
    if (!eventDetails["目標実現日"]) missingFields.push("目標実現日");
    if (!eventDetails["目標イメージ画像"] || !selectedImage) missingFields.push("イメージ画像");
    if (!eventDetails["カテゴリ"]) missingFields.push("カテゴリ");
    if (selectedTags.length === 0) missingFields.push("タグ");
    if (!eventDetails["無謀な夢の詳細"]) missingFields.push("夢の詳細");

    if (missingFields.length > 0) {
      const message = `${missingFields.join("、")}を入力してください`;
      setErrMessage(message);
      toast.error(message);
      return;
    }
    document.activeElement?.blur?.();
    navigate("/RegisterConfirmView", { state: { eventDetails } });
  };

  return (
    <React.StrictMode>
      <GlobalStyle />
      <Container>
        <RegisterForm>
          <SpacedFormGroup controlId="formBasicEvent" ref={targetRef}>
            <Form.Label>
              無謀な夢 <span className="badge bg-danger">必須</span>
            </Form.Label>
            <Form.Control name="無謀な夢" maxLength="20" type="event" placeholder="無謀な夢" onChange={handleInputChange} value={eventDetails["無謀な夢"]} required />
          </SpacedFormGroup>
          <SpacedFormGroup controlId="formBasicEventEndDate">
            <Form.Label>
              目標実現日 <span className="badge bg-danger">必須</span>
            </Form.Label>
            <Form.Control name="目標実現日" type="date" placeholder="目標実現日" onChange={handleInputChange} value={eventDetails["目標実現日"]} required />
          </SpacedFormGroup>

          <Form.Label>
            カテゴリ <span className="badge bg-danger">必須</span>
          </Form.Label>
          <DropdownContainer>
            <DropdownButton type="button" onClick={toggleDropdown} className="dropdown-button">
              {selectedOption || "選択してください"}
            </DropdownButton>
            {isOpen && (
              <DropdownMenu className="dropdown-menu" $isOpen={isOpen}>
                {categories.map((category, index) => (
                  <DropdownMenuItem
                    key={index}
                    onClick={() => {
                      console.log("クリックされたカテゴリ:", category);
                      handleOptionClick("カテゴリ", category);
                    }}
                  >
                    {category}
                  </DropdownMenuItem>
                ))}
              </DropdownMenu>
            )}
          </DropdownContainer>

          <br />
          <Form.Label>
            目標イメージ画像 <span className="badge bg-danger">必須</span>
          </Form.Label>
          <br />
          <ChapterSelectButton onClick={openModal} disabled={selectedOption === "選択してください"} variant="primary" size="lg" className="w-100 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "120px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
            画像を選択する
          </ChapterSelectButton>

          {selectedImage && (
            <div style={{ marginTop: "20px" }}>
              <Form.Label>選択された画像</Form.Label>
              <br />
              <img src={selectedImage} alt="選択された画像" style={{ width: "300px", height: "300px", objectFit: "cover" }} />
            </div>
          )}

          {isModalOpen && (
            <div style={styles.modal}>
              <div style={styles.modalContent}>
                <Form.Label>画像を選択してください</Form.Label>
                <div style={styles.scrollArea}>
                  {/* <div style={styles.thumbGrid}>
                    {imageList.map((imagePath) => (
                      <button type="button" key={imagePath} onClick={() => handleImageClick(imagePath)} style={{ display: "block", cursor: "pointer", border: 0, padding: 0, background: "transparent", width: "100%" }}>
                        <span style={styles.square}>
                          <img src={imagePath} alt="選択候補の画像" style={styles.squareImg} />
                        </span>
                      </button>
                    ))}
                  </div> */}
                  <ThumbGrid>
                    {imageList.map((imagePath) => (
                      <ThumbItem key={imagePath}>
                        <ThumbButton type="button" onClick={() => handleImageClick(imagePath)}>
                          <ThumbSquare>
                            <ThumbImg src={imagePath} alt="選択候補の画像" />
                          </ThumbSquare>
                        </ThumbButton>
                      </ThumbItem>
                    ))}
                  </ThumbGrid>
                </div>
                {/* 繝｢繝ｼ繝繝ｫ繧帝哩縺倥ｋ繝懊ち繝ｳ */}
                <Button onClick={closeModal} variant="primary" type="button" size="lg" className="w-100 text-center d-flex align-items-center justify-content-center" style={{ marginTop: "20px", minWidth: "120px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
                  キャンセル
                </Button>
              </div>
            </div>
          )}

          <br />
          <br />

          <SpacedTagsFormGroup controlId="formBasicEventTags">
            <BlockLabel>
              #タグ（最大10個）<span className="badge bg-secondary">任意</span>
            </BlockLabel>
            <BlockLabel>
              <TagFreeInput value={selectedTags} onChange={setSelectedTags} maxTags={maxTags} />
            </BlockLabel>
            <BlockLabel>よく使われているタグから選択</BlockLabel>
            <SpacedTagsFormGroup>
              {[
                "エンジニア",
                "起業",
                "会社員",
                "副業",
                "投資",
                "恋愛",
                "ダイエット",
                "健康",
                "メジャーリーグ",
                "アイドル",
                "セリエA",
                "coffee",
                "パン",
                "世界旅行",
                "バルセロナ",
                "パリコレ",
                "ノーベル賞",
                "漫画家",
                "弁護士",
                "世界一周",
                "ファン",
              ].map((tag) => (
                <StyledButton
                  key={tag}
                  type="button"
                  selected={selectedTags.includes(tag)} // 驕ｸ謚槭＆繧後※縺・ｋ縺九←縺・°繧偵メ繧ｧ繝・け
                  onClick={(e) => handleTagButtonClick(e, tag)}
                >
                  #{tag}
                </StyledButton>
              ))}
            </SpacedTagsFormGroup>
            {/* タグは最大数に達したら案内を表示 */}
            {selectedTags.length >= maxTags && <p style={{ color: "red" }}>選択できるタグは最大10個までです。</p>}
          </SpacedTagsFormGroup>
          <SpacedFormGroup controlId="formBasicEventDetails">
            <Form.Label>
              無謀な夢の詳細 <span className="badge bg-danger">必須</span>
            </Form.Label>
            <Form.Control name="無謀な夢の詳細" as="textarea" type="eventDetails" placeholder="無謀な夢の詳細" className="custom-form-control" onChange={handleInputChange} value={eventDetails["無謀な夢の詳細"]} />
          </SpacedFormGroup>
          <Button onClick={handleClick} variant="primary" type="button" size="lg" className="w-100 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "120px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
            確認画面へ
          </Button>
          {showErrorModal && (
            <div
              style={{
                position: "fixed",
                top: "30%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.3)",
                zIndex: 9999,
              }}
            >
              <p>{errMessage}</p>
              <CancelButton onClick={() => setShowErrorModal(false)} style={{ borderRadius: "8px", color: "#000000", marginTop: "10px", padding: "8px 16px" }}>
                閉じる
              </CancelButton>
            </div>
          )}
        </RegisterForm>
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover />
      </Container>
    </React.StrictMode>
  );
};

export default RegisterPage;
